// Risk-only aliases. Keep period-specific IDs intact for pricing and grading.
export const underlyingEventKey = (key) => {
  const aliases = { wnba1h: "wnba", worldcup1h: "worldcup", worldcup2h: "worldcup" };
  let result = key;
  Object.entries(aliases).forEach(([period, base]) => {
    if (result.startsWith(`${period}|`)) result = base + result.slice(period.length);
    result = result.replace(`|game:${period}_`, `|game:${base}_`);
  });
  return result;
};
